import React from "react";
import { CommonModal } from "../../../AbstractElements";
import { useForm } from "react-hook-form";

const CouponsModal = (props) => {
  const { register, watch, getValues } = useForm();

  const onInputChange = () => {
    let { searchtable } = getValues();
    props.couponSearch(searchtable);
  };
  let searchTableInput = watch("searchtable");

  // Merge coupons and offers into one combined list
  const coupons = (props.couponsData || []).map((c) => ({
    ...c,
    type: "coupon",
    displayCode: c.code,
    displayTitle: c.title,
    displayDescription: c.description,
  }));
  const offers = (props.offersData || []).map((o) => ({
    ...o,
    type: "offer",
    displayCode: o.code,
    displayTitle: o.name,
    displayDescription: o.description,
  }));
  const combinedList = [...coupons, ...offers];

  return (
    <CommonModal
      isOpen={props.isOpen}
      title={"Coupon & Offer"}
      toggler={props.toggler}
      size="md"
      bodyClass={"coupon-modal-body"}
    >
      {/* <div className="coupon-search-table">
        <div className={`input-field ${searchTableInput ? "input-active" : ""}`}>
          <input type="text" {...register("searchtable")} />
          <label htmlFor="searchtable">Enter Coupon Code</label>
          <button className="submit-search" onClick={() => onInputChange()}>
            Apply
          </button>
        </div>
      </div> */}
      <div className="available-text">Available Coupons &amp; Offers</div>
      <div className="coupons-list">
        {combinedList.length === 0 && (
          <div style={{ textAlign: "center", padding: "16px", color: "#888" }}>
            No coupons or offers available
          </div>
        )}
        {combinedList.map((item, index) => {
          return (
            <div key={`${item.type}-${item.id || item.code}-${index}`} className="individual-coupon-box">
              <div className="title-div">
                <div>
                  {item.displayTitle}
                  {item.type === "offer" && (
                    <span
                      style={{
                        marginLeft: 6,
                        fontSize: 10,
                        background: "#ff9800",
                        color: "#fff",
                        borderRadius: 4,
                        padding: "1px 6px",
                        verticalAlign: "middle",
                      }}
                    >
                      OFFER
                    </span>
                  )}
                </div>
                <button
                  className="apply-btn"
                  onClick={() => {
                    if (item.type === "offer") {
                      props.offerApply(item.displayCode, props.carDetails[0]?.id);
                    } else {
                      props.couponApply(
                        item.displayCode,
                        item.id,
                        props.carDetails[0]?.id
                      );
                    }
                  }}
                >
                  Apply
                </button>
              </div>
              <div className="description">{item.displayDescription}</div>
              <div>
                <span className="code">{item.displayCode}</span>
              </div>
            </div>
          );
        })}
      </div>
    </CommonModal>
  );
};

export default CouponsModal;
